import { PolicyType } from '@/lib/api/common/interfaces/policy.interface'
import { createRef, useEffect, useState } from 'react'

interface PolicyTypeModalProps {
    isOpen: boolean
    onClose: () => void
    onSelect: (type: PolicyType) => void
}

const policyTypeOptions = [
    { value: PolicyType.TERMS_OF_SERVICE, label: 'Termos de Uso' },
    { value: PolicyType.PRIVACY_POLICY, label: 'Política de Privacidade' },
    { value: PolicyType.COOKIE_POLICY, label: 'Política de Cookies' },
    { value: PolicyType.LGPD_PRIVACY_NOTICE, label: 'Aviso de Privacidade LGPD' },
    { value: PolicyType.GDPR_POLICY, label: 'Política GDPR' },
    { value: PolicyType.CCPA_POLICY, label: 'Política CCPA' },
    { value: PolicyType.DATA_CONSENT_DECLARATION, label: 'Declaração de Consentimento' },
    { value: PolicyType.NDA, label: 'Acordo de Confidencialidade' },
    { value: PolicyType.SECURITY_POLICY, label: 'Política de Segurança' },
    { value: PolicyType.SERVICE_CONTRACT, label: 'Contrato de Serviço' },
    { value: PolicyType.CODE_OF_CONDUCT, label: 'Código de Conduta' },
    { value: PolicyType.DATA_RETENTION_DISPOSAL_POLICY, label: 'Política de Retenção de Dados' },
    { value: PolicyType.REFUND_POLICY, label: 'Política de Reembolso' },
    { value: PolicyType.RETURN_POLICY, label: 'Política de Devolução' },
    { value: PolicyType.SHIPPING_POLICY, label: 'Política de Envio' },
    { value: PolicyType.CANCELLATION_POLICY, label: 'Política de Cancelamento' },
    { value: PolicyType.PAYMENT_POLICY, label: 'Política de Pagamento' },
    { value: PolicyType.SUBSCRIPTION_POLICY, label: 'Política de Assinaturas' },
    { value: PolicyType.ACCEPTABLE_USE_POLICY, label: 'Política de Uso Aceitável' },
    { value: PolicyType.COMMUNITY_GUIDELINES, label: 'Diretrizes da Comunidade' },
    { value: PolicyType.DISCLAIMER, label: 'Aviso Legal' },
    { value: PolicyType.END_USER_LICENSE_AGREEMENT, label: 'EULA' },
    { value: PolicyType.COPYRIGHT_POLICY, label: 'Política de Direitos Autorais' },
    { value: PolicyType.TRADEMARK_POLICY, label: 'Política de Marcas' },
    { value: PolicyType.THIRD_PARTY_POLICY, label: 'Política de Terceiros' },
    { value: PolicyType.MARKETING_POLICY, label: 'Política de Marketing' },
    { value: PolicyType.EMPLOYEE_PRIVACY_POLICY, label: 'Privacidade de Funcionários' },
    { value: PolicyType.INTERNAL_USE_POLICY, label: 'Política de Uso Interno' },
    { value: PolicyType.OTHER, label: 'Outro' },
]

export default function PolicyTypeModal({ isOpen, onClose, onSelect }: PolicyTypeModalProps) {
    const [selectedType, setSelectedType] = useState<PolicyType | null>(null)
    const modalRef = createRef<HTMLDialogElement>()

    useEffect(() => {
        if (isOpen) {
            modalRef.current?.showModal()
        } else {
            modalRef.current?.close()
        }
    }, [isOpen])

    const handleSelect = () => {
        if (selectedType) {
            onSelect(selectedType)
            onClose()
            setSelectedType(null)
        }
    }

    const handleClose = () => {
        onClose()
        setSelectedType(null)
    }

    return (
        <dialog className="modal z-50" ref={modalRef}>
            <div className="modal-box !w-full !mx-4 !max-w-md !p-0">
                <div className="flex items-center justify-between p-4 border-b border-gray-100 modal-header">
                    <h2 className="text-lg font-bold text-gray-900 modal-header-title font-nunito">
                        Selecionar Tipo de Política
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className="p-6">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-base-content mb-2">
                            Tipo de documento
                        </label>
                        <select
                            className="select select-bordered w-full"
                            value={selectedType || ''}
                            onChange={(e) => setSelectedType(e.target.value as PolicyType)}
                        >
                            <option value="">Selecione um tipo</option>
                            {policyTypeOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="flex justify-end gap-3 p-6">
                    <button
                        onClick={handleClose}
                        className="btn btn-outline-light !rounded-xl"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSelect}
                        disabled={!selectedType}
                        className="btn btn-secondary !border-0 !rounded-lg"
                    >
                        Continuar
                    </button>
                </div>
            </div>

            <form method="dialog" className="modal-backdrop">
                <button onClick={handleClose}>close</button>
            </form>
        </dialog>
    )
}
